import { FC } from "react"
import { Outlet } from "react-router-dom"

import { Grid } from "../components/mui.components"

const Uassist: FC = () => {
  return (
    <Grid
      container
      direction={"row"}
      justifyContent={"center"}
      sx={{ minHeight: "85vh" }}
      minWidth={"lg"}
    >
      <Grid container maxWidth={"lg"} sx={{ m: 0 }}>
        <Outlet />
      </Grid>
    </Grid>
  )
}

export default Uassist
